import type { FC } from "react";

import {
  EditorButtonAttachment,
  EditorButtonEmoji,
  EditorButtonGroupHistory,
  EditorButtonGroupSecondaryFormattingBlocks,
  EditorButtonGroupTextMarks,
  EditorButtonLink,
  EditorDropdownMenuTable,
  EditorDropdownMenuTextBlockFormat,
  EditorToolbar,
  EditorToolbarSeparator,
} from "../editor";
import { useEmailDraft } from "./email-draft-context";

export const EmailDraftToolbar: FC = () => {
  const { handleUploadAttachments } = useEmailDraft();

  return (
    <EditorToolbar className="flex-0 py-1!">
      <EditorDropdownMenuTextBlockFormat />
      <EditorToolbarSeparator />
      <EditorButtonGroupTextMarks />
      <EditorToolbarSeparator />
      <EditorButtonLink />
      <EditorToolbarSeparator />
      <EditorButtonAttachment onUpload={handleUploadAttachments} />
      <EditorButtonEmoji />
      <EditorButtonGroupSecondaryFormattingBlocks />
      <EditorDropdownMenuTable />
      <EditorToolbarSeparator />
      <EditorButtonGroupHistory />
    </EditorToolbar>
  );
};
